<template>
  <AppModal
    :showFooter="false"
    :show="visible"
    class="modal-term"
    @update:close="emits('close')"
    @closeModal="emits('close')"
    :extraClass="`modal-why-price-range`"
  >
    <template #header>
      <div class="dib black fs-18 lh-28 fw-700 mr-15">Why is this a price range?</div>
    </template>
    <template #body>
      <div class="modalContent">
        <p class="mb-4 mt-8">
          The estimated price range is based on our experience in designing trips to {{ destination }} and the time of year you are travelling and the standard
          of accomodation.
        </p>
        <p class="mb-8">
          The final price will vary depending on a number of factors, but should fall within this estimate. Factors that can affect the final price are:
        </p>
        <ul>
          <li v-for="(t, i) in text" :key="i" class="mb-8 flex">
            <img :src="`${ASSETS_CDN}/images/enquiryB2C/icon-check-circle.png`" alt="Icon" class="h-16 w-16" />
            <span class="ml-4">{{ t }}</span>
          </li>
        </ul>
        <p class="mb-0">
          With fully customisable itineraries we can work with you to achieve the very best value. We can amend the variables such as accommodation and
          inclusions to the best of our ability to ensure the final price sits within your desired budget.
        </p>
      </div>
    </template>
  </AppModal>
</template>
<script setup lang="ts">
import AppModal from '~/components/ui/modal/AppModal.vue'
import { assetCDN } from '~/helper'

defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  destination: {
    type: String,
    default: '',
  },
})

const emits = defineEmits(['close'])
const ASSETS_CDN = assetCDN()
const text = [
  'Standard of accommodation and proximity to the city centre.',
  'The number of activities, experiences and meals included.',
  'The number of travellers and the final dates that chosen.',
]
</script>
<style lang="scss" scoped>
:deep(.modal-why-price-range) {
  .custom-option {
    max-height: none;
    padding-top: 0;
  }
  .modal-header {
    border-color: $gray-200;
  }
}
</style>
